import styled from "styled-components";

export const PageContainer = styled.div`
  padding: 54px;
  position: relative;
  max-width: 1100px;
  margin: auto;
`;
